var Navigation = (function($, document) {
    'use strict';

    function Node($node) {
        this.$node = $($node);
        this.$anchor = this.$node.find('> a').first();
    }

    Node.prototype = {
        get: function() {
            return this.$node;
        },

        getAnchor: function() {
            return this.$anchor;
        },

        getUrl: function() {
            return this.getAnchor().attr('href');
        },

        getCategoryRootTitle: function() {
            return this.getAnchor().data('category-root-title');
        },

        getCategoryTitle: function() {
            return this.getAnchor().data('category-title');
        },

        getCategoryMetaTitle: function() {
            return this.getAnchor().data('category-meta-title') || this.getCategoryTitle();
        },

        getCategoryRootSubtitle: function() {
            return this.getAnchor().data('category-root-subtitle');
        },

        isActive: function() {
            return this.$node.hasClass('active');
        },

        isOpen: function() {
            return this.$node.hasClass('open');
        },

        isRoot: function() {
            return this.getCategoryId() === this.getCategoryRootId();
        },

        isLeaf: function() {
            return ! this.hasCategories();
        },

        hasTheSameCategoryRoot: function(node) {
            return this.getCategoryRootId() === node.getCategoryRootId();
        },

        getCategoryId: function() {
            return this.getAnchor().data('category-id');
        },

        getCategoryRootId: function() {
            return this.getAnchor().data('category-root-id');
        },

        hasCategories: function() {
            return this.get().find('li.category-node').length > 0;
        },
        
        isTargetBlank: function(){
            console.log(this.getAnchor().attr('target'));
            return this.getAnchor().attr('target');
        },

        getParentNode: function() {
            var $parentNode = this.$node.parent().closest('.category-node');

            if($parentNode.length) {
                return Navigation.makeFromAnchor($parentNode.find('> a').get(0));
            }

            return null;
        },

        select: function(markAsSelected) {
            if(markAsSelected === undefined) {
                markAsSelected = true;
            }
            var $siblings = this.get().siblings();

            $siblings.removeClass('open active').find('.open, .active').removeClass('open active');
            $siblings.find('.active-category-leaf').removeClass('active-category-leaf');

            this.get().removeClass('active');

            if(markAsSelected) {
                this.get().addClass('active');
            }

            if( this.hasCategories() ) {
                this.get().addClass('open');
                this.get().find('.active, .active-category-leaf').removeClass('active active-category-leaf');
            }
            else {
                this.get().addClass('active');
                this.get().removeClass('open');
                var parentNode = this.getParentNode();

                if(parentNode instanceof Node) {
                    parentNode.select(false);
                }

                this.getAnchor().addClass('active-category-leaf');
            }
        },

        findTheSame: function() {
            return $('.category-anchor-' + this.getCategoryId()).not(this.getAnchor());
        }
    };

    var
        isInit = false,
        $document = $(document),
        activeNode = null;

    return {
        getActiveNode: function() {
            return activeNode;
        },

        makeFromAnchor: function(object) {
            var $node = $(object).parent();

            if( ! ($node.data('node') instanceof Node) ) {
                $node.data('node', new Node( $node ));
            }

            return $node.data('node');
        },

        setup: function() {
            if(isInit) {
                return false;
            }

            var self = this;

            $document.on('click', '.category-anchor', function(e) {
                var node = self.makeFromAnchor(this);
                if(node.isTargetBlank()){
                    return true;
                }

                $document.trigger('navigation.category.selected', [node]);
                $document.trigger('navigation.category.clicked', [node]);

                e.stopPropagation();
                e.preventDefault();
            });

            $document.on('navigation.category.selected', function(e, node) {
                activeNode = node;
            });

            isInit = true;
        },

        setPlatformOf: function(containerId) {
            var $node = $(containerId).find('.category-anchor.active').parent();

            activeNode = new Node($node);
        }
    };

})(jQuery, document);
